import TopicTwo from "../../resource-contents/vps-hosting-contents/TopicTwo";

const VPSHostingContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Choose The Pips VPS</h1>
            <p>
              A reliable hosting solution designed to meet the demands of
              serious traders.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Uninterrupted Operations</h4>
                </div>
                <p>
                  Keep your EAs and trades running 24/7, unaffected by local
                  device or internet issues.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Speed That Matters</h4>
                </div>
                <p>
                  Execute trades in milliseconds, reducing slippage and
                  improving order accuracy.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Scalable Performance</h4>
                </div>
                <p>
                  Whether you manage a single account or multiple terminals,
                  enjoy flexible server capacity and resources.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VPSHostingContentFive;
